<ridango-page-content-wrapper id="main-content">
    <ridango-ui-basic-loading-spinner [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate">
    </ridango-ui-basic-loading-spinner>
</ridango-page-content-wrapper>
